module.exports = __webpack_public_path__ + "assets/img/alberto.641528d5.jpg";